import {
  GroupButton,
  HeaderTable,
  SelectPageStyled,
  TitleScreen,
} from './styled';
import React from 'react';

const HeaderListDataLayout = ({
  titleScreen,
  children,
  value,
  handleChangePageSize,
  pageSizeOptions,
  disabled,
}) => {
  return (
    <HeaderTable>
      <TitleScreen>{titleScreen}</TitleScreen>
      <GroupButton>
        {children}
        <SelectPageStyled
          value={value}
          onChange={handleChangePageSize}
          options={pageSizeOptions}
          title={''}
          disabled={disabled}
        />
      </GroupButton>
    </HeaderTable>
  );
};
export default HeaderListDataLayout;
